import logo from './../assets/images/logo.png';
import { Link } from 'react-router-dom'; 
import Navbar from './../pages/Navbar';
import Footer from './../pages/Footer';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Forgotpassword= () => { 
   //Add by Jinal
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate(); // React Router hook

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setError('');
    try { 
      //const response = await fetch('http://localhost:5121/api/LoginRegistration/forgot-password', {
      const response = await fetch('https://apiv2.chakran.in/api/LoginRegistration/forgot-password', {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }), // Ensure JSON format
      }); 
      if (!response.ok) {
        const errorResponse = await response.json();
        throw new Error(errorResponse.message || 'Something went wrong');
      }
      setMessage('Password reset link sent to your registered email.');
      
      // Delay before navigating
      setTimeout(() => {
        navigate('/login');
      }, 3000); // 2 seconds delay
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <>
    <Navbar />
      <div className="container d-flex align-items-center justify-content-center" style={{ minHeight: '90vh'}}>
        <div className="d-flex flex-column justify-content-between">
              <div className="row justify-content-center mt-5">
                <div className="col-md-10">
                  <div className="card card-default">
                    <div className="card-header">
                      <div className="app-brand w-100 d-flex justify-content-center border-bottom-0">
                        <Link className="w-auto pl-0" to="/signin">
                            <img src={logo} alt="logo" />
                            
                        </Link>
                      </div>
                    </div>
                    <div className="card-body p-5">
                      <h4 className="text-dark mb-5">Reset Your Password</h4>
                      <form onSubmit={handleSubmit}>
                        <div className="row">
                          <div className="form-group col-md-12 mb-4">
                            <input type="email" 
                             className="form-control input-lg" 
                             id="name" 
                             aria-describedby="nameHelp" 
                             placeholder="Email" 
                             value={email}
                             onChange={(e) => setEmail(e.target.value)}  
                             />
                          </div>
                          <div className="col-md-12">
                            <button type="submit" className="btn btn-primary btn-pill mb-4">Submit</button>
                            <p>Already have an account?
                            <Link className="text-blue" to="/signin"> Sign in</Link>
                            </p>
                          </div>
                        </div>
                      </form>
                      {/* Display Success or Error Messages */}
                      {message && <div className="alert alert-success mt-4">{message}</div>}
                      {error && <div className="alert alert-danger mt-4">{error}</div>}
                    </div>
                  </div>
                </div>
              </div>
            </div>   
      </div>
    <Footer />
    </>
  );
}
export default Forgotpassword;


// import React from 'react';
// import logo from './../assets/images/logo.png';
// import { Link } from 'react-router-dom'; 
// import Navbar from './../pages/Navbar';
// import Footer from './../pages/Footer';

// function Forgotpassword() {
//   return (
//     <>
//     <Navbar />
//       <div className="container d-flex align-items-center justify-content-center" style={{ minHeight: '90vh'}}>
//         <div className="d-flex flex-column justify-content-between">
//               <div className="row justify-content-center mt-5">
//                 <div className="col-md-10">
//                   <div className="card card-default">
//                     <div className="card-header">
//                       <div className="app-brand w-100 d-flex justify-content-center border-bottom-0">
//                         <Link className="w-auto pl-0" to="/signin">
//                             <img src={logo} alt="Mono" />
//                             <span className="brand-name text-dark">MONO</span>
//                         </Link>
//                       </div>
//                     </div>
//                     <div className="card-body p-5">
//                       <h4 className="text-dark mb-5">Reset Your Password</h4>
//                       <form action="#">
//                         <div className="row">
//                           <div className="form-group col-md-12 mb-4">
//                             <input type="email" className="form-control input-lg" id="name" aria-describedby="nameHelp" placeholder="Email"/>
//                           </div>
//                           <div className="col-md-12">
//                             <button type="submit" className="btn btn-primary btn-pill mb-4">Submit</button>
//                             <p>Already have an account?
//                             <Link className="text-blue" to="/signin"> Sign in</Link>
//                             </p>
//                           </div>
//                         </div>
//                       </form>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>   
//       </div>
//     <Footer />
//     </>
//   );
// }
// export default Forgotpassword;
